/**
 * Merges any number of `Validator`s into a single `Validator`
 */
export function merge() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (value, props) {
        return fns.reduce(function (acc, fn) {
            if (acc !== undefined)
                return acc;
            return fn(value, props);
        }, undefined);
    };
}
//# sourceMappingURL=merge.js.map